





























































































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import CardHeader from '@/components/Registration/Header.vue';
import Container from '@/components/Registration/Container.vue';
import RegistrationCard from '@/components/Registration/Card.vue';
import BasicSignupForm from './BasicSignupForm.vue';
import SignupFooter from './Footer.vue';
import { User } from '../../models/userdata/userdto';
import basicFormValidator from './basicFormValidator';
import resumeValidator from './resumeValidator';
import { OtherSignUp } from '../../models/jobrolesignup/othersignup';
import Multiselect from 'vue-multiselect';
import MultipleSelectWithCheckbox from '@/components/Commons/MultipleSelectWithCheckbox.vue';

@Component({
  components: {
    CardHeader,
    Container,
    RegistrationCard,
    BasicSignupForm,
    SignupFooter,
    Multiselect,
    MultipleSelectWithCheckbox,
  },
})
export default class OtherSignup extends Mixins(
  basicFormValidator,
  resumeValidator,
) {
  $wlToastr: any;
  private basicFormValues = new User();
  private otherSignUP: OtherSignUp = new OtherSignUp();
  private otherFormErrors = {
    resume: '',
    currentJobTitle: '',
    currentCompany: '',
    passportCountry: '',
  };

  mounted() {
    vxm.roleSignup.setMarketingMail(false);
    vxm.passport.fetchCountryList();
    vxm.roleSignup.fetchPilotLicenseCategory();
    vxm.roleSignup.fetchJobHistoryMetaData();
    vxm.roleSignup.fetchChildCompanies();
  }

  updatePassportCountries(newValue, oldValue) {
    this.otherSignUP.passportCountries = [];
    newValue.forEach((element) => {
      this.otherSignUP.passportCountries.push(element.countryId);
    });
  }

  addTag(newTag) {
    const tag = {
      text: newTag,
      value: newTag,
    };
    this.airlineCompanies.push(tag);
    this.otherSignUP.currentCompany = tag;
  }

  get airlineCompanies() {
    return vxm.roleSignup.ChildCompanies.map((opt) => {
      return {
        value: opt.name,
        text: opt.name,
      };
    });
  }

  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }

  get passportCountries() {
    return vxm.passport.CountryList;
  }

  validateOtherSignupForm() {
    this.otherFormErrors = {
      resume: '',
      currentJobTitle: '',
      currentCompany: '',
      passportCountry: '',
    };
    let isValid: boolean = true;

    // if (this.resumePayload.resume.resumename === '') {
    //   this.otherFormErrors.resume = 'signup.resume.required';
    // }

    if (!this.otherSignUP.currentJobTitle) {
      this.otherFormErrors.currentJobTitle = 'signup.currentJobTitle.required';
    }

    if (!this.otherSignUP.currentCompany.value) {
      this.otherFormErrors.currentCompany = 'signup.employer.required';
    }

    if (!this.otherSignUP.passportCountries.length) {
      this.otherFormErrors.passportCountry = 'signup.passport.required';
    }

    Object.keys(this.otherFormErrors).forEach((key) => {
      isValid = isValid && !this.otherFormErrors[key];
    });
    return isValid;
  }

  async registerUser() {
    const basicFormValid = this.validateBasicForm(this.basicFormValues);
    const resumeFileValid = this.validateResume();
    const otherSignupFormValid = this.validateOtherSignupForm();
    if (basicFormValid && resumeFileValid && otherSignupFormValid) {
      const response = await vxm.roleSignup.basicSignup(this.basicFormValues);
      if (response.success) {
        await vxm.users.refreshProfileInfo();
        let userProfile: any = vxm.users.myUserProfile;
        userProfile.notificationTypeMap = {
          ...userProfile.notificationTypeMap,
          MARKETING_EMAIL: vxm.roleSignup.MarketingEmail,
        };
        userProfile.doNotTriggerEvent = 'true';
        const jobHistoryData = {
          doNotTriggerEvent: 'true',
          currentJob: true,
          companyInfo: {
            companyName: this.otherSignUP.currentCompany.value,
          },
          jobRole: this.otherSignUP.currentJobTitle,
          jobHistoryCustomData: {
            [vxm.roleSignup.CustomFieldMappings.role]: 'Other',
          },
          startDTTM: new Date().getTime(),
        };

        const passportData = this.otherSignUP.passportCountries.map(
          (element) => {
            return {
              identificationMasterId: element,
              doNotTriggerEvent: 'true',
            };
          },
        );
        const resumeFile = this.resumePayload.resumefile;
        const formData = new FormData();
        formData.append('userProfileData', JSON.stringify(userProfile));
        formData.append('jobHistoryData', JSON.stringify(jobHistoryData));
        formData.append('passportData', JSON.stringify(passportData));
        formData.append('resumefile', resumeFile);
        const response = await vxm.roleSignup.megaSignup(formData);
        if (response.meta && response.meta.success) {
          this.$router.push('home');
          this.$wlToastr(
            'success',
            'You have successfully signed up',
            'Sign up',
          );
          if (response.data) {
            if (!response.data.jobHistoryData) {
              this.$wlToastr(
                'error',
                'Work experience information not saved. Please try again from Work experience section.',
                'Sign up',
              );
            }
            if (!response.data.passportData) {
              this.$wlToastr(
                'error',
                'Passport information not saved. Please try again from Passport section.',
                'Sign up',
              );
            }
            if (!response.data.userProfileData) {
              this.$wlToastr(
                'error',
                'Profile information not saved. Please try again from profile section.',
                'Sign up',
              );
            }
            if (!response.data.resumeFile) {
              this.$wlToastr(
                'error',
                'Resume is not saved. Please try again from profile section.',
                'Sign up',
              );
            }
          }
        }
      } else {
        this.$wlToastr('error', response.errorMessage, 'Sign up');
      }
    }
  }
}
